$('.frame-type-mask_hofmann_locationssearchmap .job-radius-slider').each(function () {
  const $this = $(this);
  const $targetInput = $(`#${$this.data('target')}`);
  const startValue = parseInt($targetInput.val(), 10) || 25;
  const overrideOptions = {
    range: {
      min: 5,
      '60%': [50, 50],
      '70%': [100, 100],
      '80%': [200, 100],
      '90%': [300, 700],
      max: 1000,
    },
  };
  const distanceUnit = (typeof HofmannSettings !== 'undefined' && HofmannSettings && HofmannSettings.distanceUnit) || 'km';

  let sliderOptions = {
    start: [startValue],
    step: 5,
    range: {},
    pips: {
      mode: 'values',
      values: [5, 50, 100, 200, 300, 1000],
      density: 1000,
      stepped: true,
      filter: function (value, type) {
        return 2;
      },
      format: {
        to: function (numericValue) {
          if (window.innerWidth <= 600 && (numericValue >= 100 && numericValue <= 900)) {
            return numericValue.toFixed(0);
          }
          return `${numericValue.toFixed(0)}${distanceUnit}`;
        }
      }
    },
    tooltips: {
      to: function (numericValue) {
        return `${numericValue.toFixed(0)}${distanceUnit}`;
      },
    },
  };
  sliderOptions = $.extend(true, {}, sliderOptions, overrideOptions);

  // eslint-disable-next-line no-undef
  noUiSlider.create(this, sliderOptions).on('change.one', function (values, handle, rawValues) {
    $targetInput.val(Math.floor(rawValues[0]));
    $targetInput.trigger('change');
    $targetInput.closest('form').trigger('submit');
    // $jobSearchMainInput.closest('form').find('.job-search-submit-btn').trigger('click');
  });
  const slideResponsiveUpdateOrChange = function () {
    $this[0].noUiSlider.updateOptions(sliderOptions, true);
  };
  // slideResponsiveUpdateOrChange(); // Initial call only required if options has changed
  $(window).resize(slideResponsiveUpdateOrChange);
});
